exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/customer-detail/customer-detail.component.css
// module id = ../../../../../src/app/customer-detail/customer-detail.component.css
// module chunks = main